import React, { useState } from "react";
import "./CustomerPage.scss"
import AddIcon from "@mui/icons-material/Add";
import { Box, Fab, Typography } from "@mui/material";
import PersonaFisicaTableComponent from "../../components/customer/pef/PersonaFisicaTableComponent";
import ExcelExportButton from "../../components/shared/ExcelExportButton";
import { GridColDef } from "@mui/x-data-grid";
import { useQuery } from "react-query";
import { fetchSelectAllPF } from "../../api/personafisica";
import { fetchPFsQueryKey } from "../../utils/QueryClient";
import { FetchPaginatedApiModel } from "../../models/shared/CommonModels";
import { PersonaFisicaModel } from "../../models/PersonaFisicaModel";
import GroupsIcon from "@mui/icons-material/Groups";

const PersonaFisicaPage: React.FC<{}> = () => {

  const [fabVisible, setFabVisible] = useState(true)
  const [persone, setPersone] = useState<FetchPaginatedApiModel<PersonaFisicaModel[]>>(undefined as any)
  
  useQuery({
    queryKey: [fetchPFsQueryKey],
    queryFn: () => fetchSelectAllPF(0, undefined, { id: 0, field: "id", direction: "asc" }),
    onSuccess: (getResponse) => {
      setPersone(getResponse.data);
    },
    refetchOnWindowFocus: false,
  });

  const excelColumns: GridColDef[] = [
    { field: "id", headerName: "ID Cliente", width: 100 },
    { field: "nome", headerName: "Nome", width: 150 },
    { field: "cognome", headerName: "Cognome", width: 150 },
    { field: "codice_fiscale", headerName: "Codice Fiscale", width: 150 },
    { field: "data_nascita", headerName: "Data di Nascita", width: 120 },
    { field: "genesi_cliente", headerName: "Genesi del Cliente", width: 180 },
  ];

  const excelRows = persone?.data?.map(pf => ({
    id: pf.id,
    nome: pf.nome,
    cognome: pf.cognome,
    codice_fiscale: pf.codice_fiscale,
    data_nascita: new Date(Date.parse(pf.data_di_nascita)).toLocaleDateString("it-IT"),
    genesi_cliente: pf.anagraficacliente.genesi_cliente,
  })) || [];

  return (
    <>
      {fabVisible &&
        <Fab
          onClick={() => setFabVisible(false)}
          sx={{ position: "fixed", bottom: 16, right: 16 }} color="primary" aria-label="add">
          <AddIcon />
        </Fab>
      }
      <Box sx={{ mb: 3 }}>
        <Box sx={{ 
          display: "flex", 
          alignItems: "center", 
          gap: 2,
          mb: 2,
          pb: 2,
          borderBottom: "2px solid",
          borderColor: "primary.main"
        }}>
          <GroupsIcon sx={{ fontSize: 40, color: "primary.main" }} />
          <Typography 
            variant="h4" 
            sx={{ 
              fontWeight: 600,
              color: "primary.main",
              letterSpacing: "0.5px"
            }}
          >
            Clienti
          </Typography>
        </Box>
      </Box>
      <PersonaFisicaTableComponent 
        alterFabVisibility={setFabVisible} 
        fabVisible={fabVisible}
        toolbarActions={
          <ExcelExportButton 
            columns={excelColumns}
            rows={excelRows}
          />
        }
      />
    </>
  )
}

export default PersonaFisicaPage;
